module.exports = __webpack_public_path__ + "static/img/MICHAEL_CLARKE.4519d54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MICHAEL_CLARKE.jpg
// module id = np4g
// module chunks = 0